<iframe [src]="JagaMapUrl | jagaSafe: 'resourceUrl'"
        frameborder="0"
        style="border:0;"
        allowfullscreen=""
        aria-hidden="false"
        tabindex="0">
</iframe>
